module.exports = __webpack_public_path__ + "img/tron (56).917bd568.jpg";